// extracted by mini-css-extract-plugin
module.exports = {"main":"community_main__VaQAC","left":"community_left__e3DLz","right":"community_right__3nC9y","recommend":"community_recommend__UlQ40"};